import { render, staticRenderFns } from "./CheckoutInfo.vue?vue&type=template&id=4d4dc85c&scoped=true"
import script from "./CheckoutInfo.vue?vue&type=script&lang=js"
export * from "./CheckoutInfo.vue?vue&type=script&lang=js"
import style0 from "./CheckoutInfo.vue?vue&type=style&index=0&id=4d4dc85c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4dc85c",
  null
  
)

export default component.exports